import { render } from "./cancelled-coach.vue?vue&type=template&id=c8a30040"
import script from "./cancelled-coach.vue?vue&type=script&lang=js"
export * from "./cancelled-coach.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__